import { useState, useEffect, useMemo } from 'react';
import RestaurantCard from '../components/restaurant/RestaurantCard';
import RestaurantDetail from '../components/restaurant/RestaurantDetail';
import FiltersBar from '../components/restaurant/FiltersBar';
import { EmptyState, Spinner, Button } from '../components/ui/UI';
import { fetchRestaurants, getStatutForUser } from '../lib/api';
import { useAuth } from '../hooks/useAuth';

export default function ATesterPage({ onAddClick }) {
  const { user } = useAuth();
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({ cuisine: 'tous', prix: 'tous', noteMin: '0', search: '', createur: 'tous' });

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try { setRestaurants(await fetchRestaurants()); }
    finally { setLoading(false); }
  }

  // Ne montre que les restaurants où MON statut personnel = 'tester'
  const filtered = useMemo(() => {
    return restaurants
      .filter(r => {
        // Si pas connecté : montre tout
        const monStatut = user ? getStatutForUser(r, user.id) : 'tester';
        if (monStatut !== 'tester') return false;
        if (filters.cuisine !== 'tous' && r.type_cuisine !== filters.cuisine) return false;
        if (filters.prix !== 'tous' && String(r.niveau_prix) !== filters.prix) return false;
        if (filters.createur && filters.createur !== 'tous' && r.added_by_profile?.username !== filters.createur) return false;
        if (filters.search) {
          const s = filters.search.toLowerCase();
          if (!r.nom.toLowerCase().includes(s) && !r.adresse.toLowerCase().includes(s)) return false;
        }
        return true;
      })
      .map(r => ({ ...r, monStatut: 'tester' }));
  }, [restaurants, filters, user]);

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '32px 20px' }}>
      <div style={{ marginBottom: 32, animation: 'slideUp 0.4s ease' }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(28px,5vw,42px)', fontWeight: 800, marginBottom: 8 }}>
          📌 À tester
        </h1>
        <p style={{ color: 'var(--text-3)', fontSize: 16 }}>
          {user
            ? `${filtered.length} restaurant${filtered.length > 1 ? 's' : ''} sur votre liste personnelle`
            : `${filtered.length} restaurants`}
        </p>
      </div>

      <FiltersBar filters={filters} onChange={setFilters} showStatut={false} restaurants={restaurants} />

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '80px 0' }}><Spinner size={40} /></div>
      ) : filtered.length === 0 ? (
        <EmptyState
          icon="📌"
          title="Votre liste est vide"
          subtitle={user ? "Tous vos restaurants ont été testés, ou ajoutez-en de nouveaux !" : "Connectez-vous pour gérer votre liste personnelle."}
          action={user ? <Button onClick={onAddClick}>+ Ajouter un restaurant</Button> : null}
        />
      ) : (
        <div className="stagger" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 }}>
          {filtered.map(r => (
            <div key={r.id} className="animate-slideUp">
              <RestaurantCard restaurant={r} monStatut="tester" onClick={() => setSelectedId(r.id)} />
            </div>
          ))}
        </div>
      )}

      <RestaurantDetail restaurantId={selectedId} open={!!selectedId} onClose={() => setSelectedId(null)} onUpdate={load} />
    </div>
  );
}
